import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import DatePickerInput from '../../components/DatePicker';
import Link from '../../components/Link';
import CustomSelect from '../../components/Select';

function AccountStatement() {
  const [selectValue, setSelectValue] = useState<string>('');
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    if (selectValue !== 'custom-date' && selectValue !== '') {
      setIsValid(true);
    } else if (selectValue === 'custom-date' && startDate && endDate) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [selectValue, startDate, endDate]);

  const handleChange = (e: any) => {
    setSelectValue(e);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const handleSelectStartDate = (e: any) => {
    setStartDate(e);
  };

  const handleSelectEndDate = (e: any) => {
    setEndDate(e);
  };

  const options = [
    { value: 'month-to-date', label: 'Month to Date' },
    { value: 'year-to-date', label: 'Year to Date' },
    { value: 'last-quarter', label: 'Last Quarter' },
    { value: 'last-year', label: 'Last Year' },
    { value: 'custom-date', label: 'Custom Date' },
  ];

  return (
    <Container className="cnd-custom-container my-13 px-0 container">
      <Container>
        <Row lg={2} sm={1}>
          <Col className={'col-12 col-lg-6'}>
            <Container className={'px-0'}>
              <Col className={'p-0'}>
                <h3 className={'mb-lg-7 mb-md-5 text-sm-24-lg-48'}>
                  Account Statement
                </h3>
                <div className={'fw-light lh-xs text-fs-6'}>
                  <p className={'m-0'}>
                    You can create an account statement showing your 401(k)
                    performance over a period of time
                  </p>
                </div>
              </Col>

              <Container className={'px-0 d-lg-none px-10 py-13'}>
                <img
                  className={'d-block mx-auto img-fluid'}
                  style={{ width: '250px' }}
                  alt={'rcs'}
                  src={`${process.env.PUBLIC_URL}/${'account-statement.png'}`}
                ></img>
              </Container>

              <Col className={'p-0'}>
                <h3 className={'mt-lg-13 mb-10 text-sm-20-lg-24'}>
                  Statement Period
                </h3>

                <Col className={'fw-light lh-xs text-fs-6'}>
                  <CustomSelect
                    options={options}
                    placeholder="Select"
                    onChange={handleChange}
                    // {...field}
                  />
                </Col>
                {selectValue === 'custom-date' && (
                  <Col className={'d-flex flex-column flex-sm-row mt-sm-5'}>
                    <Col>
                      <DatePickerInput
                        placeholder={'Select a date'}
                        label={'Start Date'}
                        className="mt-7 me-sm-3 "
                        onChange={(date) => handleSelectStartDate(date)}
                        maxDate={new Date()}
                      />
                    </Col>
                    <Col>
                      <DatePickerInput
                        placeholder={'Select a date'}
                        label={'End Date'}
                        className="mt-7 ms-sm-3"
                        onChange={(date) => handleSelectEndDate(date)}
                        maxDate={new Date()}
                      />
                    </Col>
                  </Col>
                )}

                <Col className="my-10 my-lg-11 d-flex flex-column flex-lg-row">
                  <Link
                    style={{ pointerEvents: `${isValid ? 'auto' : 'none'}` }}
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                    target={'_blank'}
                  >
                    <Button
                      variant="primary"
                      rightIcon={light('file-pdf')}
                      disabled={!isValid}
                    >
                      Create Statement
                    </Button>
                  </Link>
                </Col>
              </Col>
            </Container>
          </Col>
          <Col className={'col-lg-6 px-13 d-none d-lg-block'}>
            <Container className={'px-0 my-lg-10'}>
              <img
                className={'d-block mx-auto img-fluid'}
                style={{ width: '350px' }}
                alt={'rcs'}
                src={`${process.env.PUBLIC_URL}/${'account-statement.png'}`}
              ></img>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default AccountStatement;
